import styled, { keyframes, css } from "styled-components";

// Large border radius
const PILL_BORDER_RADIUS = 500;

const fillFromCenter = keyframes`
    0% {
        width: 0%;
        left: 50%;
        right: 50%;
    }
    100% {
        width: 100%;
        left: 0%;
        right: 0%;
    }
`;

const ripple = keyframes`
    0% {
        transform: translate(-50%, -50%) scale(1, 1);
        opacity: 0.8;
    }
    20% {
        transform: translate(-50%, -50%) scale(1.3, 1.7);
        opacity: 0;
    }
    20.01%, 100% {
        transform: translate(-50%, -50%) scale(1, 1);
        opacity: 0;
    }
`;

const rippleSecond = keyframes`
    0% {
        transform: translate(-50%, -50%) scale(1, 1);
        opacity: 0;
    }
    20% {
        transform: translate(-50%, -50%) scale(1, 1);
        opacity: 0.8;
    }
    40% {
        transform: translate(-50%, -50%) scale(1.3, 1.7);
        opacity: 0;
    }
    40.01%, 100% {
        transform: translate(-50%, -50%) scale(1, 1);
        opacity: 0;
    }
`;

export const TimerPillWrapper = styled.div<{
    $shouldFill: boolean;
    $showRipple: boolean;
    $defaultBgColor?: string;
    $urgencyBgColor: string;
    $skipFillAnimation?: boolean;
}>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${({ theme }) => `calc(${theme.spacing.xLarge} * 3 - ${theme.spacing.xxxSmall})`};
    height: ${({ theme }) => `calc(${theme.spacing.medium} * 2 - ${theme.spacing.xxxSmall})`};
    border-radius: ${({ theme }) => `calc(${theme.spacing.large} * 2)`};
    font-size: ${({ theme }) => theme.spacing.small};
    position: relative;
    overflow: visible;
    background: ${({ $defaultBgColor }) =>
        $defaultBgColor ||
        "linear-gradient(346deg, rgba(252, 228, 250, 0.23) -19.06%, rgba(255, 183, 250, 0.23) 94.28%)"};
    z-index: 1;

    &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        width: ${({ theme }) => `calc(${theme.spacing.xLarge} * 3 - ${theme.spacing.xxxSmall})`};
        height: ${({ theme }) => `calc(${theme.spacing.medium} * 2 - ${theme.spacing.xxxSmall})`};
        border-radius: ${PILL_BORDER_RADIUS}px;
        border: ${({ theme, $urgencyBgColor }) => `${theme.spacing.xxxSmall} solid ${$urgencyBgColor}`};
        opacity: 0;
        pointer-events: none;
        z-index: -1;
        transform-origin: center center;
        ${({ $showRipple }) =>
            $showRipple
                ? css`
                      animation: ${ripple} 10s ease-out infinite;
                  `
                : css`
                      animation: none !important;
                      display: none !important;
                  `}
    }

    ${({ $shouldFill, $urgencyBgColor, $skipFillAnimation, theme }) =>
        $shouldFill
            ? css`
                  &::before {
                      content: "";
                      position: absolute;
                      top: 0;
                      bottom: 0;
                      left: ${$skipFillAnimation ? "0%" : "50%"};
                      right: ${$skipFillAnimation ? "0%" : "50%"};
                      width: ${$skipFillAnimation ? "100%" : "auto"};
                      background: ${$urgencyBgColor};
                      border-radius: calc(${theme.spacing.large} * 2);
                      ${$skipFillAnimation
                          ? ""
                          : css`
                                animation: ${fillFromCenter} 0.2s ease-out forwards;
                            `}
                      z-index: 0;
                  }
              `
            : ""}

    ${({ $showRipple, $urgencyBgColor, theme }) =>
        $showRipple
            ? css`
                  & .ripple-second {
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      width: calc(${theme.spacing.xLarge} * 3 - ${theme.spacing.xxxSmall});
                      height: calc(${theme.spacing.medium} * 2 - ${theme.spacing.xxxSmall});
                      border-radius: ${PILL_BORDER_RADIUS}px;
                      border: ${theme.spacing.xxxSmall} solid ${$urgencyBgColor};
                      opacity: 0;
                      pointer-events: none;
                      z-index: -1;
                      transform-origin: center center;
                      animation: ${rippleSecond} 10s ease-out infinite;
                  }
              `
            : css`
                  & .ripple-second {
                      animation: none !important;
                      display: none !important;
                  }
              `}

    ${({ $shouldFill }) =>
        $shouldFill
            ? css`
                  & > * {
                      position: relative;
                      z-index: 1;
                  }
              `
            : ""}

    .timer-pill-center {
        margin-right: 0 !important;
        border: none !important;
        padding: 0 !important;
        height: 100% !important;
        width: 100% !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
    }
`;
